exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.info-container[data-v-373aabc4] {\n  height: 99%;\n  width: 100%;\n  padding-bottom: 60px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n", "", {"version":3,"sources":["D:/java/social-training/省内平台手机/src/view/employment/D:/java/social-training/省内平台手机/src/view/employment/employment.vue"],"names":[],"mappings":";AA8CA;EACE,YAAW;EACX,YAAW;EACX,qBAAoB;EACpB,+BAAsB;UAAtB,uBAAsB;CACvB","file":"employment.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n.info-container {\r\n  height: 99%;\r\n  width: 100%;\r\n  padding-bottom: 60px;\r\n  box-sizing: border-box;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-373aabc4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/employment/employment.vue
// module id = 4whY
// module chunks = 49